import { render } from "./TrialByTrialData.vue?vue&type=template&id=baa26c64&scoped=true"
import script from "./TrialByTrialData.vue?vue&type=script&lang=js"
export * from "./TrialByTrialData.vue?vue&type=script&lang=js"

import "./TrialByTrialData.vue?vue&type=style&index=0&id=baa26c64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baa26c64"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QColor from 'quasar/src/components/color/QColor.js';import TouchHold from 'quasar/src/directives/TouchHold.js';
import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBadge,QChip,QAvatar,QIcon,QMenu,QList,QItem,QItemSection,QColor});qInstall(script, 'directives', {TouchHold,Ripple});
